import React, { useState, useEffect } from 'react';
import Tour from 'reactour';

const defaultStepStyle = {
  color: '#484848',
  background: '#ffffff'
};

function WebTour({ steps, isOpenByDefault = true }) {
  const [isTourOpen, setIsTourOpen] = useState(isOpenByDefault);

  useEffect(() => {
    setIsTourOpen(isOpenByDefault);
  }, [isOpenByDefault]);

  const closeTour = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "tour_closed"
    });
    setIsTourOpen(false);
  };
  if (!steps || !steps.length) return null;
  return (
    <Tour
      steps={steps}
      isOpen={isTourOpen}
      maskStyle={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      rounded={5}
      stepInteraction={true}
      maskClassName="tour-mask"
      accentColor="var(--main-primary-color)"
      colors={"#ffffff"}
    onRequestClose={closeTour}
    />
  );
}

export { defaultStepStyle };
export default WebTour;